import { ComponentBaseConfigModel } from '../component-base-config.model';

export interface FeatureInfoConfigModel extends ComponentBaseConfigModel {
  defaultShowDropdown: boolean;
  showEditButton?: boolean;
  hideEmptyValues?: boolean;
}
